import classNames from 'classnames';
import * as React from 'react';
const Tabs = ({ children, className, ...rest }) => (React.createElement("ul", { className: classNames(className, 'ixu-tabs'), ...rest }, children));
export default Tabs;
//# sourceMappingURL=Tabs.js.map